import { memo, useCallback, useEffect, useState } from "react";
import SelectErp from "../../../../components/basics/SelectErp";
import { useFluxoDeCaixaService } from "../contexts";
const SelectFilter = ({
  setFilter,
  filterOptions,
  filterMatch,
  label,
  disabled,
  loading,
}) => {
  const { getOptionsToList } = useFluxoDeCaixaService();
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (!options.length && Object.keys(filterOptions).length)
      setOptions(getOptionsToList(filterOptions));
  }, [filterOptions, getOptionsToList, options, setOptions]);

  const getValue = useCallback(
    (listed) => listed?.find((option) => option?.value === filterMatch) || [],
    [filterMatch]
  );

  return (
    <SelectErp
      disabled={disabled}
      disableClearable
      label={label}
      loading={loading}
      lg={2}
      value={getValue(options)}
      onChange={(option) => {
        setFilter(option?.value);
      }}
      optionsList={options}
      descriptionField="description"
    />
  );
};

export default memo(SelectFilter);
